import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody, CardHeader, CardTitle, Row, Col, Progress } from 'reactstrap';
import MetricCard from './metricCard';
import { pct } from './qualityAgentHelpers';
const SummarySection = ({
  summary
}) => {
  const passRate = pct(summary.passed || 0, summary.totalChecks || 0);
  return /*#__PURE__*/React.createElement(Card, {
    className: "shadow-sm h-100"
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: "bg-white"
  }, /*#__PURE__*/React.createElement(CardTitle, {
    tag: "h5",
    className: "mb-0 quality-agent__card-title"
  }, "Executive Summary")), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("p", {
    className: "text-muted mb-4 quality-agent__summary-text"
  }, summary.assessmentMessage || 'No summary available.'), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, {
    className: "g-3 mb-4"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(MetricCard, {
    title: "Total Checks",
    value: summary.totalChecks
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(MetricCard, {
    title: "Passed",
    value: summary.passed,
    color: "success"
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(MetricCard, {
    title: "Failed",
    value: summary.failed,
    color: "danger"
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(MetricCard, {
    title: "Warnings",
    value: summary.warnings,
    color: "warning"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between small mb-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-muted"
  }, "Overall pass rate"), /*#__PURE__*/React.createElement("span", {
    className: "fw-medium"
  }, passRate, "%")), /*#__PURE__*/React.createElement(Progress, {
    value: passRate,
    color: (() => {
      if (passRate >= 80) return 'success';
      if (passRate >= 50) return 'warning';
      return 'danger';
    })(),
    className: "quality-agent__progress-bar"
  }))));
};
SummarySection.propTypes = {
  summary: PropTypes.shape({
    assessmentMessage: PropTypes.string,
    totalChecks: PropTypes.number,
    passed: PropTypes.number,
    failed: PropTypes.number,
    warnings: PropTypes.number
  }).isRequired
};
export default SummarySection;